<template>
  <AiChat :open="visible" ref="aiChat" :quote="{
    type: 'aichat.hint',
    name: `${formData.name}-语音${~~insertConf.index + 1}`,
    workId: 'OPTIMIZE_CALL_SCRIPT',
    hint: `节点名称:${formData.name}\n节点文本:${formData.voices && formData.voices[insertConf.index] && formData.voices[insertConf.index].text}`
  }" @on-close="cancelHandler" @on-insert="onInsert" :title="nodeDetail && nodeDetail.id ? '编辑跳转节点' : '增加跳转节点'">
    <div class="content">
      <Form class="form-content" :model="formData" ref="form" :label-width="110" :rules="ruleValidate">
        <FormItem label="节点名称" prop="name">
          <Input v-model="formData.name" placeholder="" />
        </FormItem>
        <FormItem label="下一步" >
          <Select v-model="formData.action"  style="width: 100px; margin-right: 15px" >
            <Option value="jump">跳转</Option>
            <Option value="hangup">挂机</Option>
            <Option value="transfer">转接</Option>
          </Select>
          <form-item-jump-action v-if="formData.action === 'jump'" v-model="formData.action_data" />
        </FormItem>
        <form-item-voices
          label="话术文本"
          v-model="formData.voices"
          @openAi="(index) => {
            openAi('confirm_voice', index)
          }"
        /><!-- 是否支持打断 -->
        <form-item-can-break v-model="formData.can_break" />
        <FormItem label="前">
          <InputNumber v-model="formData.break_delay" :min="0" :disabled="!formData.can_break"/><span style="margin-left: 5px">ms不打断</span>
        </FormItem>
        <FormItem label="延迟播放">
          <InputNumber v-model="formData.playback_delay" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <FormItem label="协同提醒">
          <div>
            <i-switch v-model="formData.hmc_remind"/>
            <span style="margin-left: 15px;" v-if="formData.hmc_remind">
              <SkillSelect v-model="formData.hmc_skill_id" v-if="access.userSkill"/>
            </span>
          </div>
        </FormItem>
        <form-item-node-transfer v-model="formData" />
        <FormItem label="启用按键">
          <i-switch v-model="formData.enable_dtmf"/>
        </FormItem>
        <FormItem label="收号长度">
          <InputNumber v-model="formData.dtmf_digits_length" :min="0" placeholder="收号长度 0-不限制" :disabled="!formData.enable_dtmf" />
        </FormItem>
        <FormItem label="收号终止字符" prop="dtmf_terminator">
          <Input v-model="formData.dtmf_terminator"  :disabled="!formData.enable_dtmf"/>
        </FormItem>
        <FormItem label="等待响应超时时长">
          <InputNumber v-model="formData.input_timeout" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <form-item-tag v-model="formData.tag"/>
        <form-item-var v-model="formData.vars"/>
      </Form>
      <div class="btn">
        <Button style="margin-right: 20px" color="#547ed1" @click="cancelHandler">取消</Button>
        <Button
          type="primary"
          style="margin-right: 20px"
          color="#547ed1"
          @click="submit"
        >
          确定
        </Button>
      </div>
    </div>
  </AiChat>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { mapState } from 'vuex'
import FormItemTag from '@/components/FormItemTag.vue'
import FormItemVar from '@/components/FormItemVar.vue'
import FormItemCanBreak from '../../../components/FormItemCanBreak.vue'
import FormItemVoices from '../../../components/FormItemVoices.vue'
import FormItemJumpAction from '../../../components/FormItemJumpAction.vue'
import SkillSelect from '../../../components/SkillSelect.vue';
import { addNodeId } from '@/utils/nodeIdPool'
import AiChat from '@/views/aiChat/index'
import FormItemNodeTransfer from '@/components/FormItemNodeTransfer.vue';
import { normalizeNodeTransfer } from '@/utils/nodeTransfer';

export default {
  components: {
    FormItemVar,
    FormItemTag,
    FormItemCanBreak,
    FormItemNodeTransfer,
    FormItemVoices,
    FormItemJumpAction,
    SkillSelect,
    AiChat
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeDetail: {
      type: Object,
    }
  },
	computed: {
    ...mapState('flow', [
			'flows'
    ]),
    ...mapState('user', ['access']),
  },
  data() {
    const validatedtmfTerminator = (rule, value, callback) => {
        if(value === '') {
          callback()
        } else if (value.lenth > 1) {
            callback(new Error('只支持1位'))
        } else if (!['0','1','2','3','4','5','6','7','8','0','*','#'].includes(value)) {
            callback(new Error('只支持0-9、*、#'))
        } else {
            callback()
        }
    }
    return {
      title: '',
      formData: {
        name: '',
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        hmc_remind: false,
        hmc_skill_id: '',
        hmc_after_play: false,
        can_delay_hmc: false,
        hmc_delay: 1,
        action: 'jump',
        action_data: '',
				tag: '',
        voices: [{ voice: '', text: '', id: addNodeId('V') }], // 录音
				vars: [],
        input_timeout: 0,
        enable_dtmf: false, // 是否启用按键
        dtmf_digits_length: 0, // 收号长度 0-不限制
        dtmf_terminator: '', // 收号终止字符
      },
      insertConf: {
        type: '',
        index: 0,
      },
      ruleValidate: {
        name: [
          { required: true, message: '节点名不能为空', trigger: 'blur' },
        ],
        dtmf_terminator: [
          { validator: validatedtmfTerminator },
        ],
      }
    };
  },
	watch: {
		nodeDetail(val) {
			if (!val) {
        this.resetFormData();
        return;
      }
      this.formData = {
        ...this.formData,
        ...cloneDeep(val),
        ...normalizeNodeTransfer(val),
        action: val.action,
      }
		}
	},
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = {
          ...cloneDeep(this.formData),
          ...normalizeNodeTransfer(this.formData),
          type: 'jump',
          action: this.formData.action || '',
          action_data: this.formData.action === 'jump' ? this.formData.action_data : '',
          hmc_skill_id: this.formData.hmc_remind ? this.formData.hmc_skill_id : '',
        }
        formData.voices = formData.voices.filter(item => item.text || item.voice);
        if(this.formData.id) {
          this.$emit('editNode', formData)
        } else {
          this.$emit('addNode', formData)
        }
        this.cancelHandler();
      })
    },
    cancelHandler() {
      try {
        this.resetFormData();
      } catch (error) {
        // 改成多段录音后 form.resetFields 后报错
        console.log('error :>> ', error);
      }
      this.$emit('change', false)
      this.$emit('cancel')
      this.insertConf = {
        type: '',
        index: 0,
      }
    },
    resetFormData() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        hmc_remind: false,
        hmc_skill_id: '',
        hmc_after_play: false,
        can_delay_hmc: false,
        hmc_delay: 1,
        action: 'jump',
        action_data: '',
        tag: '',
        voices: [{ voice: '', text: '', id: addNodeId('V') }], // 录音
        vars: [],
        enable_dtmf: false, // 是否启用按键
        dtmf_digits_length: 0, // 收号长度 0-不限制
        dtmf_terminator: '', // 收号终止字符
      }
    },
    openAi(type, index) {
      this.insertConf = {
        type,
        index
      }
      setTimeout(() => {
        this.$refs.aiChat.sendMessage('文案优化')
      }, 100)
    },
    onInsert(text) {
      const { index } = this.insertConf
      this.formData.voices[index].text = text;
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.form-content {
  overflow-y: auto;
  flex: 1;
}
.btn {
  width: 100%;
  background: #fff;
  padding: 10px 16px;
  text-align: right;
	border-top: 1px solid #e8e8e8;
}
.vars-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
}
.var-line {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.var-form {
	flex: 1;
}
.var-del-icon {
	margin-left: 10px;
	font-size: 16px;
}
</style>
